/// <reference types="@types/googlemaps" />
import { Component, HostListener, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { crop_Datas, FarmerLandModel, SelectedCropModel } from '../../../models/farmer-land.model';
import { FarmerLandDetailService } from '../../../services/farmer-land-detail.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { Message, MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { saveAs } from 'file-saver'
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { TreeNode } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'farmer-land-detail',
  templateUrl: './farmer-land-detail.component.html',
  styleUrls: ['./farmer-land-detail.component.scss'],
  providers: [MessageService],
})
export class FarmerLandDetailComponent implements OnInit {
  public farmerLandForm: FormGroup;
  uploadedFiles: any[] = [];
  valRadio: boolean;
  valActive: any;
  productDialog: boolean;
  selectedVillage: any;
  selectedCropType: any;
  filteredVillage: any[];
  filteredCorpType: any[];
  lstFarmerLandModel: FarmerLandModel[];
  farmerLandModel: FarmerLandModel;
  selectedFarmerLand: FarmerLandModel[];
  submitted: boolean;
  statuses: any[];
  items: MenuItem[];
  selectedNodes1: any[] = [];
  nodes2: any[];
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  editFLModel: FarmerLandModel;
  selectedCropNodes: any;
  blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/; 
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  location: any;
  innerWidth: number;
  public loading: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }


  villageList = [];

  cropTypeItems = [
    { Name: 'Alabama', Code: '1' },
    { Name: 'Alaska', Code: '2' },
    { Name: 'Arizona', Code: '3' },
  ];
  farmerId: any;
  ipAddress: any = '000.000.000';

  constructor(
    private _personalDetalSer: FarmersDetailsService, 
    private primengConfig: PrimeNGConfig, 
    private service: MessageService, 
    private _formBuilder: FormBuilder, 
    private flService: FarmerLandDetailService, 
    private messageService: MessageService, 
    private confirmationService: ConfirmationService, 
    private productService: BankDetailService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    ) { }

  ngOnInit() {
    this.getIP();
    this.getCorpType();
    this.innerWidth = window.innerWidth;
    this.items = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel();
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf();
        }
      },
    ];

    this.farmerLandForm = this._formBuilder.group({
      totalArea: ['', [Validators.required]],
      morabbaNumber: [, [Validators.required]],
      killaNumber: [, [Validators.required]],
      kanals: ['', Validators.compose([Validators.required, Validators.max(8)])],
      marlas: ['', Validators.compose([Validators.required, Validators.max(20)])],
      village: ['', [Validators.required]],
      latitude: ['',''],
      longitude: ['', ''],
      cropType: ['', [Validators.required]],
      IsSubsidyAvailabe: ['', [Validators.required]],
      landdoc_Path: ['', [Validators.required]],
      leaseDoc_Path: ['',],
    });
    // this.f.totalArea.disable();
    this.primengConfig.ripple = true;
    // this.loadData();
    this.getFarmerId();
    this.getVillageData();
    this.filteredCorpType = [...this.cropTypeItems]

  }

  getFarmerId() {
    let mobile = sessionStorage.getItem('farmerPh');
    // this.loader.start();
    this.loading = true;
    this.productService.getFarmerIdByMobileNo(mobile).subscribe(resp => {
     // this.loader.close();
     this.loading = false;
      if (resp.statusCode === 200) {
        this.activityRecordService.activityRecord(mobile, 'Land Details', '', new Date(), 'Success');

        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;
          // console.log(this.farmerId);

          this.loadData()
        }
      }
      else{
        this.activityRecordService.activityRecord(mobile, 'Land Details', '', new Date(), 'Invalid');
      }
    }, err => {
      // this.loader.close();
      this.loading = false;
    })
  }

  loadData() {
    // let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    // if (farmerData) {
      // this.loader.start();
    this.loading = true;
    this.flService.Get(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          if (data.Table.length > 0) {
            this.lstFarmerLandModel = data.Table;
          }
        },
        error: () => {
          // this.loader.close();
          this.loading = false;
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Land Details not loaded.' });

        }
      });
    // }
  }

  get f() {
    return this.farmerLandForm.controls;
  }

  openNew() {
    this.editFLModel = new FarmerLandModel();

    this.f.totalArea.reset();
    this.f.morabbaNumber.reset();
    this.f.killaNumber.reset();
    this.f.kanals.reset();

    this.f.marlas.reset();
    this.f.village.reset();
    this.f.latitude.reset();
    this.f.longitude.reset();
    this.f.cropType.reset();

    this.submitted = false;
    this.productDialog = true;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.farmerLandForm.invalid) {
      return;
    }
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    if (!farmerData) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }
    this.getSelectedCorpType();
    this.farmerLandModel = new FarmerLandModel();
    this.farmerLandModel.land_ID = 0;
    this.farmerLandModel.farmerID = this.farmerId;
    this.farmerLandModel.total_Area = this.f.totalArea.value;
    this.farmerLandModel.morbno = this.f.morabbaNumber.value;
    this.farmerLandModel.killano = this.f.killaNumber.value;
    this.farmerLandModel.kanal = this.f.kanals.value;
    this.farmerLandModel.marla = this.f.marlas.value;
    this.farmerLandModel.village_Code = this.f.village.value.Code;
    this.farmerLandModel.lat = this.f.latitude.value ? this.f.latitude.value : 0;
    this.farmerLandModel.long = this.f.longitude.value ? this.f.longitude.value : 0;
    this.farmerLandModel.is_Available_Lease = this.valRadio;
    this.farmerLandModel.landdoc_Path = this.f.landdoc_Path.value;
    this.farmerLandModel.lease_Agrement_Doc = this.valRadio ? this.f.leaseDoc_Path.value : '';
    this.farmerLandModel.user_ID = farmerData.Farmer_ID;
    this.farmerLandModel.network_ID = this.ipAddress;
    this.farmerLandModel.terminal_ID = this.ipAddress;
    this.farmerLandModel.active = "1";
    this.farmerLandModel.crop_Datas = this.selectedCorpModelList;

    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    if (this.editFLModel.Land_ID > 0) {
      this.farmerLandModel.land_ID = this.editFLModel.Land_ID;
      // this.loader.start();
    this.loading = true;
      this.flService.UpdateLandDetails(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.loadData();
            this.activityRecordService.activityRecord(mobile, 'Land Details Updated', '', new Date(), data, this.farmerLandModel);
            if(data == 'Success'){
              this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
            }
            else{
              this.service.add({ severity: 'info', summary: 'Info Message', detail: JSON.stringify(data) });
            }
            this.productDialog = false;
            this.farmerLandForm.reset()
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'Land Details Updated', '', new Date(), err, this.farmerLandModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
          }
        });
    }
    else {
      // this.loader.start();
    this.loading = true;
      this.flService.InsertLandDetails(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.loadData();
            this.activityRecordService.activityRecord(mobile, 'Land Details Inserted', '', new Date(), data, this.farmerLandModel);
            if(data == 'Success'){
              this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
            }
            else{
              this.service.add({ severity: 'info', summary: 'Info Message', detail: JSON.stringify(data) });
            }
            this.productDialog = false;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'Land Details Inserted', '', new Date(), err, this.farmerLandModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
          }
        });
    }

  }

  getSelectedCorpType() {
    this.selectedCorpModel = new crop_Datas();
    this.selectedCorpModelList = [];
    let selectedLabels = [];
    for (let result of this.selectedNodes1) {
      if (result.parent) {
        if(selectedLabels.includes(result.label)){
          break;
        }
        let body = {
          crop_ID : result.data,
          type_of_crop_ID: result.parent?.data
        }
        this.selectedCorpModelList.push(body);
        selectedLabels.push(result.label);
      }else if(result.children){
        result.children.forEach(child => {
          if(selectedLabels.includes(child.label)){
            return;
          }
          let body = {
            crop_ID : child.data,
            type_of_crop_ID: (child.parent?.data) ? child.parent?.data : result.data
          }

          this.selectedCorpModelList.push(body);
          selectedLabels.push(child.label);
        })
      }
    }
    // console.log("Crop Datas: ", this.selectedCorpModelList);
  }

  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
    this.farmerLandForm.reset()
    // console.log(this.farmerLandForm);

  }

  public setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    }
  }


  showPosition(position) {
    let geocoder = new google.maps.Geocoder;
    let latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
    this.f.latitude.setValue(position.coords.latitude);
    this.f.longitude.setValue(position.coords.longitude);
  }

  getCorpType() {
    this.flService.GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.nodes2 = files
        },
        error: () => {
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Corp Type Details not loaded.' });

        }
      });
  }

  editProduct(bank: any) {
    this.editFLModel = new FarmerLandModel();

    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    let flModel = { ...bank };
    this.f.totalArea.setValue(flModel.Total_Area);
    this.f.morabbaNumber.setValue(flModel.Morabba_No);
    this.f.killaNumber.setValue(flModel.Killa_No);
    this.f.kanals.setValue(flModel.Kanals);

    this.f.marlas.setValue(flModel.Marlas);

    this.f.latitude.setValue(flModel.Lat);
    this.f.longitude.setValue(flModel.Long);
    this.valRadio = flModel.IS_Avalibe_for_Lease;
    this.f.cropType.setValue(flModel.Crop_Type_ID);
    this.f.landdoc_Path.setValue(flModel.Land_Doc);
    this.editFLModel = flModel;
    this.productDialog = true;

    let village = this.villageList.filter(val => val.Code === flModel.Village_Code)[0]
    this.f.village.setValue(village.Name);
    this.selectedVillage = village;
    if (parseInt(this.f.kanals.value) >= 8) {
      this.f.marlas.disable();
    }
  }

  filterCorpType(event: any) {
    // console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.cropTypeItems.length; i++) {
      const corpType = this.cropTypeItems[i];
      if (corpType.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(corpType);
      }
    }

    this.filteredCorpType = filtered;
    // console.log(this.filteredCorpType);

  }

  filterVillage(event: any) {
    // console.log(event);

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
    // console.log(this.filteredVillage);

  }

  deleteProduct(bank: any) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.farmerLandModel = new FarmerLandModel();
        this.farmerLandModel.farmerID = this.farmerId;
        this.farmerLandModel.landID = bank.Land_ID;
        this.farmerLandModel.user_ID = sessionStorage.getItem('abyUserID') ? sessionStorage.getItem('abyUserID') :sessionStorage.getItem("userID");
        this.farmerLandModel.network_ID = this.ipAddress;
        this.farmerLandModel.terminal_ID = this.ipAddress;
        // this.loader.start();
        this.loading = true;
        this.flService.DeleteLandDetails(this.farmerLandModel)
          .pipe(first())
          .subscribe({
            next: (data) => {
              // this.loader.close();
            this.loading = false;
              this.loadData();
              if(data == "Deleted Successfully!"){
                this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
              }
              else{
                this.service.add({ severity: 'info', summary: 'INfo Message', detail: JSON.stringify(data) });
              }

              this.activityRecordService.activityRecord(mobile, 'Land Details Delete', '', new Date(), data, this.farmerLandModel);
            },
            error: (err) => {
              // this.loader.close();
            this.loading = false;
              this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
              this.activityRecordService.activityRecord(mobile, 'Land Details Delete', '', new Date(), err, this.farmerLandModel);

            }
          });
      }
    });
  }

  onKanalsChange() {
    let tlk: any = 0.00;// sample kanal variable
    let tlm: any = 0.00;// sample marlas variable
    this.f.marlas.setValue(0);
    if (this.f.kanals.value) {
      if (parseInt(this.f.kanals.value) >= 8) {
        this.f.marlas.setValue(0);
        this.f.marlas.disable();
        // tlm = 1;
      }
      else {
        this.f.marlas.enable();
      }
      tlk = parseInt(this.f.kanals.value) * 0.125;
    }
    if (this.f.marlas.value) {
      tlm = parseInt(this.f.marlas.value) * 0.006249999998;
    }

    let tl = tlk + tlm;
    const totalArea = tl.toFixed(2)
    this.f.totalArea.setValue(Number(totalArea));
  }

  onMarlasChange() {
    let tlk: any = 0.00;
    let tlm: any = 0.00;
    if (this.f.kanals.value != undefined || this.f.kanals.value != '') {
      tlk = (this.f.kanals.value ? parseInt(this.f.kanals.value) : 0) * 0.125;
    }
    if (this.f.marlas.value != undefined || this.f.marlas.value != '') {
      tlm = (this.f.marlas.value ? parseInt(this.f.marlas.value): 0) * 0.006249999998;
    }
    // if (this.f.marlas.value > 19){
    //   this.f.marlas.setValue()
    // }

    let tl = tlk + tlm;
    this.f.totalArea.setValue(parseFloat(tl).toFixed(2));
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      // this.loader.close();
      this.loading = false;
      // console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if(!window.sessionStorage.getItem("villageMaster")){
        window.sessionStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }
  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.lstFarmerLandModel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "Farmer Land");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf() {

    this.cols = [
      // { field: 'farmerName', header: 'Farmers Name'},
      { field: 'Land_ID', header: 'Land ID' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Morabba_No', header: 'Morabba Number' },
      { field: 'Killa_No', header: 'Killa Number' },
      { field: 'Kanals', header: 'Kanals' },
      { field: 'Marlas', header: 'Marlas' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.lstFarmerLandModel);
        doc.save('Farmer Land.pdf');
      })
    })
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this._personalDetalSer.uploadFile(data, sessionStorage.getItem('farmerPh'), formcontrol).subscribe((resp: any) => {
      // console.log(resp);
      if (resp.statusCode == 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
        this.farmerLandForm.patchValue({ [formcontrol]: resp.data });
        // console.log(resp.data.replace("http://localhost:44320/", "http://10.100.60.76:98/"));

      }

    })
    uploadElement.clear();
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

}
